import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
function LoadingView() {
  return /*#__PURE__*/_jsx(UILoadingSpinner, {
    grow: true,
    layout: "centered",
    showLabel: true,
    size: "md"
  });
}
export default LoadingView;